import React from 'react';
import styled from 'styled-components/macro';
import { Search } from 'lib/components';
import {
  PrimaryButton,
  ComponentProps as PrimaryButtonsProps,
} from 'lib/components/buttons/PrimaryButton';
import { theme } from 'lib/style';
import { MdFileDownload } from 'react-icons/md';

const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  width: 304px;
  justify-content: space-between;
`;

const StyledButton = styled(PrimaryButton)`
display: flex;
flex-direction: row;
align-items: center;
padding: 8px 16px 8px 8px;
gap: 4px;

position: absolute;
height: 40px;
right: 95px;
top: 284px;
background: #EEEFF2;
border-radius: 5px;
margin = '0 0 0 8px'
`;

const IconBtn = (props: PrimaryButtonsProps) => (
  <StyledButton
    center={true}
    iconPadding={8}
    textPadding='16px 16px 16px 8px'
    margin='0 0 0 24px'
    // margin = '0 0 0 8px'
    //   textPadding = '8px 16px'
    //   iconPadding = '8px 0px 8px 12px'
    backgroundColor={theme.palette.primaryDarkBlue10Percent}
    textColor={theme.palette.black_1_100}
    iconMargin={0}
    {...props}
  />
);

type FilterProps = {
  marginRight?: number;
  width?: number;
};
const Filter = styled.div<FilterProps>`
  min-width: 224px;
  width: ${props => `${props.width}px` || 'auto'};
  margin-right: ${props => `${props.marginRight}px` || '0px'};
`;

type Props = {
  onSearch(search: string): void;
  prevSearch?: string;
  downloadOptOutReports(): void;
};

export const SearchAndFilterForOptOuts = ({
  prevSearch,
  onSearch,
  downloadOptOutReports,
}: Props) => {
  return (
    <FiltersContainer>
      <Filter width={536} marginRight={12}>
        <Search
          placeholder='Search by name or email...'
          onSearch={onSearch}
          prevSearch={prevSearch}
        />
        <IconBtn
          text='Download .csv'
          icon={<MdFileDownload color={theme.palette.black_1_100} />}
          onClick={downloadOptOutReports}
        />
      </Filter>
    </FiltersContainer>
  );
};
